<template>
    <div id="TestDiv">
    </div>
</template>

<script> 

export default {
  name: 'BookTest',
  components: { },
  beforeCreate () { },
  data () {
    return { }
  },
  mounted: function () {
    this.$router.push({ path: '/lab' })
  },
  created () { },
  watch: { },
  methods: { }
}
</script>


// WEBPACK FOOTER //
// src/components/web/Book/Test.vue